<template>
    <div class="box-second">
        <p class="title">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>设备管理</el-breadcrumb-item>
                <el-breadcrumb-item>监控设备</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="build-bar">
                <span>设备名称：</span>
                <el-input placeholder="请输入项目名称" v-model="tableDataName"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>
                <el-button type="primary" @click="addRow()">添加设备</el-button>
            </div>
            <div class="build-table">
               <el-card class="box-card" v-for="(item,index) in tableDataEnd" :key="index" style="margin-top:1vh;">
                <div slot="header" class="clearfix" style="display:flex;align-items: center;justify-content: space-between;cursor: pointer;">
                  <span @click="toList(item)" style="display: inline-block;width: 80%;text-align: left;cursor: pointer;color:#409EFF;">{{index+1}}、{{item.name}}</span>
                  <div style="display:flex;align-items: center;">
                    <el-button size="mini" @click="handleEdit(index, item)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(index, item)">删除</el-button>
                    <el-button size="mini" style="background:#fff;color:#000;" @click="monitorSyn(item)">手动同步</el-button>
                  </div>
                </div>
                <div v-if="item.linkType=='2'" style="width:100%;height:6vh;position: relative;display:flex;flex-wrap:wrap;align-items: center;">
                  <div style="width:33%;height:4vh;position: relative;text-align: left;">
                    序列号：{{item.serial}}
                  </div>
                  <div style="width:33%;height:4vh;position: relative;text-align: left;">
                    验证码：{{item.vcode}}
                  </div>
                  <div style="width:33%;height:4vh;position: relative;text-align: left;">
                    时间：{{item.createDate}}
                  </div>
                  <div style="width:33%;height:4vh;position: relative;text-align: left;">
                    是否硬盘录像机：{{item.hardFlag=='1'?'是':'否'}}
                  </div>
                  <div style="width:33%;height:4vh;position: relative;text-align: left;">
                    备注：{{item.remarks}}
                  </div>
                </div>
                <div v-else-if="item.linkType=='3'" style="width:100%;height:6vh;position: relative;display:flex;flex-wrap:wrap;align-items: center;">
                  <div style="width:33%;height:4vh;position: relative;text-align: left;">
                    账号：{{item.username}}
                  </div>
                  <div style="width:33%;height:4vh;position: relative;text-align: left;">
                    IP：{{item.ip}}
                  </div>
                  <div style="width:33%;height:4vh;position: relative;text-align: left;">
                    时间：{{item.createDate}}
                  </div>
                  <div style="width:33%;height:4vh;position: relative;text-align: left;">
                    密码：{{item.password}}
                  </div>
                  <div style="width:33%;height:4vh;position: relative;text-align: left;">
                    端口1：{{item.port}}
                  </div>
                  <div style="width:33%;height:4vh;position: relative;text-align: left;">
                    端口2：{{item.port2}}
                  </div>
                </div>
                <div v-else-if="item.linkType=='1'" style="width:100%;height:6vh;position: relative;display:flex;flex-wrap:wrap;align-items: center;">
                  <div style="width:33%;height:4vh;position: relative;text-align: left;">
                    序列号：{{item.serial}}
                  </div>
                  <div style="width:33%;height:4vh;position: relative;text-align: left;">
                    验证码：{{item.vcode}}
                  </div>
                  <div style="width:33%;height:4vh;position: relative;text-align: left;">
                    时间：{{item.createDate}}
                  </div>
                  <div style="width:33%;height:4vh;position: relative;text-align: left;">
                    是否硬盘录像机：{{item.hardFlag=='1'?'是':'否'}}
                  </div>
                  <div style="width:33%;height:4vh;position: relative;text-align: left;">
                    备注：{{item.remarks}}
                  </div>
                </div>
              </el-card>
                <!-- <el-table :data="tableDataEnd" ref="tableDataBegin" height="100%" style="width: 100%;"> -->
                <!-- <template slot="empty">
                    <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号" width="80">
                    <template slot-scope="scope">
                    <span>{{ scope.row.index }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="名称">
                    <template slot-scope="scope">
                    <router-link
                        style="color:#17b2fe"
                        :to="{name:'monitEquipList',params: { id:scope.row.id,type:scope.row.machType }}"
                    >{{ scope.row.name}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column label="序列号">
                    <template slot-scope="scope">
                    <span>{{ scope.row.serial }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="验证码">
                    <template slot-scope="scope">
                    <span>{{ scope.row.vcode }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="备注">
                    <template slot-scope="scope">
                    <span>{{ scope.row.remarks }}</span>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column label="操作" width="320">
                    <template slot-scope="scope">
                      <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                      <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                      <el-button size="mini" style="background:#fff;color:#000;" @click="monitorSyn(scope.row)" >手动同步</el-button>
                      <el-button size="mini" type="success" @click="toDecrypt(scope.row)">解密</el-button>
                    </template>
                </el-table-column> -->

                <!-- 新增窗口 -->
                <el-dialog
                    :title="dialogTitle"
                    :visible.sync="addFormVisible"
                    center
                    :append-to-body="true"
                    :lock-scroll="false"
                    class="add-form"
                    width="30%"
                >
                    <el-tabs v-model="curMachType">
                    <el-tab-pane label="萤石云" name="1">
                        <el-form
                        :model="addForm"
                        ref="addForm"
                        label-width="100px"
                        id="formData"
                        :label-position="labelPosition"
                        :rules="rules"
                        >
                        <el-form-item label="名称：" prop="name">
                            <el-input v-model="addForm.name" placeholder="请输入名称" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="硬盘录像机：">
                            <el-radio-group v-model="addForm.hardFlag">
                            <el-radio label="1">是</el-radio>
                            <el-radio label="0" style="margin-left:20px;">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="序列号：">
                            <el-input v-model="addForm.serial" placeholder="请输入序列号" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="验证码：">
                            <el-input v-model="addForm.vcode" placeholder="请输入验证码" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="备注：">
                            <el-input type="textarea" v-model="addForm.remarks"></el-input>
                        </el-form-item>
                        </el-form>
                        <div class="dialog-footer" style="margin-top:20px;text-align: center;">
                        <el-button @click="addFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                        </div>
                    </el-tab-pane>
                   <el-tab-pane label="网络直连" name="3">
                    <el-form
                    :model="addForm3"
                    ref="addForm3"
                    label-width="100px"
                    id="formData"
                    :label-position="labelPosition"
                    :rules="rules"
                    >
                      <el-form-item label="名称：" prop="name">
                          <el-input v-model="addForm3.name" placeholder="请输入名称" autocomplete="off"></el-input>
                      </el-form-item>
                      <el-form-item label="硬盘录像机：">
                          <el-radio-group v-model="addForm3.hardFlag">
                          <el-radio label="1">是</el-radio>
                          <el-radio label="0" style="margin-left:20px;">否</el-radio>
                          </el-radio-group>
                      </el-form-item>
                      <el-form-item label="IP：">
                          <el-input v-model="addForm3.ip" placeholder="请输入IP地址" autocomplete="off"></el-input>
                      </el-form-item>
                      <el-form-item label="端口号：">
                          <el-input v-model="addForm3.port" placeholder="请输入端口号" autocomplete="off"></el-input>
                      </el-form-item>
                      <el-form-item label="端口号2：">
                          <el-input v-model="addForm3.port2" placeholder="请输入端口号" autocomplete="off"></el-input>
                      </el-form-item>
                      <el-form-item label="用户名：">
                          <el-input v-model="addForm3.username" placeholder="请输入" autocomplete="off"></el-input>
                      </el-form-item>
                      <el-form-item label="密码：">
                          <el-input v-model="addForm3.password" placeholder="请输入" autocomplete="off"></el-input>
                      </el-form-item>
                      <el-form-item label="备注：">
                          <el-input type="textarea" v-model="addForm3.remarks"></el-input>
                      </el-form-item>
                    </el-form>
                    <div class="dialog-footer" style="margin-top:20px;text-align: center;">
                      <el-button @click="addFormVisible = false">取 消</el-button>
                      <el-button type="primary" @click="sumbitAddRow3('addForm3')">确 定</el-button>
                    </div>
                  </el-tab-pane>
                    <el-tab-pane label="大华监控" name="2">
                        <el-form
                        :model="addForm1"
                        ref="addForm1"
                        label-width="100px"
                        :label-position="labelPosition"
                        :rules="rules1"
                        >
                        <el-form-item label="名称：" prop="name">
                            <el-input v-model="addForm1.name" placeholder="请输入名称" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="硬盘录像机：">
                            <el-radio-group v-model="addForm1.hardFlag">
                            <el-radio label="1">是</el-radio>
                            <el-radio label="0" style="margin-left:20px;">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="序列号：">
                            <el-input v-model="addForm1.serial" placeholder="请输入序列号" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="验证码：">
                            <el-input v-model="addForm1.vcode" placeholder="请输入验证码" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="备注：">
                            <el-input type="textarea" v-model="addForm1.remarks"></el-input>
                        </el-form-item>
                        </el-form>
                        <div class="dialog-footer" style="margin-top:20px;text-align: center;">
                        <el-button @click="addFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="sumbitAddRow1('addForm1')">确 定</el-button>
                        </div>
                    </el-tab-pane>
                    </el-tabs>
                </el-dialog>
                <!-- </el-table> -->

                <!-- 表单列表 -->
                <!-- <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[3, 5, 10]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
                ></el-pagination>-->
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../../untils/util'
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
export default {
    data() {
    return {
      dialogTitle: '编辑窗口', //弹出框标题
      labelPosition: 'right', // 添加设备弹出框position属性
      machType: '1', // 添加窗口-tag默认显示页
      addForm: {}, // 添加设备表单数组
      addForm1: {}, // 编辑设备表单数组
      addForm3: {},
      radio: 1, // 弹窗口-录像机是否传值
      addFormVisible: false, // 弹出框是否显示
      tableDataName: '', // 搜索数据名
      tableDataEnd: [], // 监控表单数据
      currentPage: 1, // 表单列表默认页
      pageSize: 10, // 表单列表默认显示数
      totalItems: 0, // 表单列表全部长度
      flag: false, // 搜索数据flag值
      groupId: util.session.get('groupId'),
      curMachType: '1', //当前设备  1：海康   2：大华
      dataText: '数据加载中...',
      rules: {
        name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }]
      },
       rules1: {
        name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    // 搜索数据 111
    doFilter() {
      if (this.tableDataName == '') {
        this.$message.warning('查询条件不能为空！')
        return
      }
      var that = this
      var option = {
        name: this.tableDataName,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        deviceName: '',
        projectId: util.session.get('groupId')
      }
      myHttp.getMonitListByProjectId(option).then(function(resp) {
        if (resp.data.code == '200') {
          var list = resp.data.data.monitorList || [],
            arr = []
          for (var i = 0; i < list.length; i++) {
            if (list[i].name.split(that.tableDataName).length > 1) {
              arr.push(list[i])
              list[i].index = arr.length
            }
          }
          that.tableDataEnd = arr
          if (that.tableDataEnd != '') {
            that.$message.success('搜索结果如下')
          } else {
            that.$message.error('数据不存在')
          }
          console.log(that.tableDataEnd.index)
        } else {
          that.$message.error(resp.data.msg)
        }
      })
      // this.currentPage = 1
      // this.currentChangePage()
      // this.flag = true
    },
    // handleSizeChange(val) {
    //   this.pageSize = val
    //   this.handleCurrentChange(this.currentPage)
    // },
    // handleCurrentChange(val) {
    //   console.log(`当前页: ${val}`)
    //   this.currentPage = val
    //   this.getData()
    // },
    // // 监控当前页码
    // currentChangePage() {
    //   this.getData()
    // },

    // 获取数据
    getData() {
      var option = {
        name: this.tableDataName,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        deviceName: '',
        projectId: util.session.get('groupId')
      }
      var that = this
      myHttp.getMonitListByProjectId(option).then(
        function(resp) {
          if (resp.data.code == '200') {
            // console.log(resp.data.data.monitorList)
            var list = resp.data.data.monitorList || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
            }
            that.tableDataEnd = list
            that.totalItems = list.length
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },

    // 编辑数据
    handleEdit(index, row) {
      this.dialogTitle = '编辑设备信息'
      this.addFormVisible = true
      this.curMachType = row.linkType
      if (row.linkType == '1') {
        this.addForm = row
      } else if(row.linkType == '3'){
        this.addForm3 = row
      } else {
        this.addForm1 = row
      }
    },

    // 删除数据
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          myHttp.monitorDeleteInfo({
            id: row.id
          }).then(function(resp) {
            if (resp.data.code == '200') {
              that.$message.success('删除成功')
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      })
    },

    /**
     * 新增设备
     */
    addRow() {
      // console.log(this.addForm.id);
      this.dialogTitle = '新增设备'
      this.addFormVisible = true
      //海康-萤石云
      this.addForm = {
        id: '',
        name: '',
        machType: '1',
        linkType: '1',
        hardFlag: '1', //是否有硬盘录像机
        serial: '',
        vcode: '',
        remarks: '',
        projectId: util.session.get('groupId')
      }
       //硬盘录像机-直连
      this.addForm3 = {
        id: '',
        name: '',
        machType: '4',
        linkType: '3',
        hardFlag: '1', //是否有硬盘录像机
        ip: '',
        port: '',
        port2:'',
        username:'',
        password:'',
        remarks: '',
        projectId: util.session.get('groupId')
      }
      //大华
      this.addForm1 = {
        id: '',
        name: '',
        machType: '2',
        linkType: '2',
        hardFlag: '1', //是否有硬盘录像机
        serial: '',
        vcode: '',
        remarks: '',
        projectId: util.session.get('groupId')
      }
    },

    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (that.addForm.id == '') {
            //添加
            myHttp.monitorCreateInfo(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.addFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          } else {
            //修改
            delete that.addForm.cameraList
            delete that.addForm.createDate
            if (that.addForm.password == '') {
              delete that.addForm.password
            }
            myHttp.monitorUpdateInfo(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.addFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          }
        }
      })
    },
    sumbitAddRow1(formName) {
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (that.addForm1.id == '') {
            myHttp.monitorCreateInfo(that.addForm1).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.addFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          } else {
            delete that.addForm1.cameraList
            delete that.addForm1.createDate
            myHttp.monitorUpdateInfo(that.addForm1).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.addFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          }
        }
      })
    },
       // 网络直连
    sumbitAddRow3(formName) {
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (that.addForm.id == '') {
            //添加
            myHttp.monitorCreateInfo(that.addForm3).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.addFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          } else {
            //修改
            delete that.addForm3.cameraList
            delete that.addForm3.createDate
            if (that.addForm3.password == '') {
              delete that.addForm3.password
            }
            myHttp.monitorUpdateInfo(that.addForm3).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.addFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          }
        }
      })
    },
    //同步
    monitorSyn(row) {
        var that = this
        myHttp.registerMonitor({
          id: row.id
        }).then(function(resp) {
          if (resp.data.code == '200') {
            that.$message.success('同步摄像头成功')
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    cancel() {
      this.addFormVisible = false
      this.editFormVisible = false
    },
    // 关闭弹出框弹窗
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },

    //解密
    toDecrypt(row){
      var that = this
      myHttp.encryptOffMonitor({
        projectId: this.groupId,
        serial:row.serial,
        vcode:row.vcode
      }).then(function(resp){
        console.log(resp)
        if(resp.data.code=='200'){
          that.$message.success('解密成功')
        }else{
          that.$message.error(resp.data.msg)
        }
      })
    },
     //进入摄像头页面
    toList(row){
      this.$router.push({path:'/monitEquipList/'+row.id+'/'+row.linkType})
    },
  }
}
</script>
<style scoped>
    .box-second{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .title{
        width: 100%;
        height: 3vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding-left: 1vw;
    }
    .main{
        width: 100%;
        height: calc( 100% - 3vh );
        position: relative;
        display: flex;
        padding: 0 1vw 0.5vw;
        flex-wrap: wrap;
    }
    .build-bar {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 80px;
        /* border-top: 3px solid rgb(224, 224, 224); */
        border-bottom: 3px solid #17b2fe;
        background: #fff;
    }

    .build-bar span {
        margin-left: 30px;
        white-space: nowrap;
        display: inline-block;
    }

    .build-bar > .el-input {
        width: 200px;
        font-size: 12px;
    }

    .build-bar > .el-button {
        margin-left: 30px;
        background-color: #17b2fe;
        border-color: #17b2fe;
    }

    .build-bar > .el-button:last-child {
        margin-right: 20px;
    }

    .build-bar .btnLef {
        position: absolute;
        right: 6%;
        display: block;
        width: 95px;
        height: 40px;
        line-height: 40px;
        color: #fff;
        border-radius: 4px;
        background: #ffaf15;
        border: 1px solid #ffb800;
    }

    .el-select .el-input {
        width: 130px;
    }

    .input-with-select .el-input-group__prepend {
        background-color: #fff;
    }

    .build-table {
        position: relative;
        width: 100%;
        background: #fff;
        height: calc( 100% - 8vh );
    }

    .el-table .el-table-column:not(:first-child) {
        border: 1px solid slategrey;
    }

    .el-table >>> .cell {
        overflow: hidden;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
    }

    .add-form {
        margin-top: 3vh;
    }

    .add-form .el-form-item {
        margin-top: 20px;
    }

    .el-pagination {
        padding: 20px 0;
    }
</style>